module.exports = __webpack_public_path__ + "fonts/Roboto-400-latin7.b009a76.woff2";